import { useAuthedUserContext } from '@/clients/shared-hooks/use-authed-user';
import { useBodyScroll } from '@/clients/shared-hooks/use-body-scroll';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { LanguageSwitcher } from './LanguageSwitcher';
import { Logo } from './Logo';
import { UserAvatarMenu } from './UserAvatarMenu';
import styles from './signed-in.module.css';

export function Header({ children }: PropsWithChildren) {
  const { isOnboarded } = useAuthedUserContext();
  const { direction, amount } = useBodyScroll();

  const hideNavbar = direction === 'down' && amount > 10;
  const navbarClassName = `${styles.navbar} ltr:pr-6 rtl:pl-6 ${hideNavbar ? styles.hidden : ''}`;
  const headerClassName = amount < 10 ? '' : 'shadow';

  return (
    <header className={headerClassName}>
      <div className="flex flex-col">
        <div className={navbarClassName}>
          <Link to="/" className="flex items-center px-4">
            <Logo height={34} width="auto" color="var(--text-base)" />
          </Link>
          <div id="header-insert-div">{children}</div>
          {isOnboarded && (
            <div className="flex gap-4 items-center">
              <div className="ltr:border-r rtl:border-l border-warm-10 rtl:pl-1 ltr:pr-1">
                <LanguageSwitcher />
              </div>
            </div>
          )}
          <div className="flex items-center ltr:pl-3 rtl:pr-3">
            <UserAvatarMenu />
          </div>
        </div>
      </div>
      <div id="header-insert-progress-tracker" />
    </header>
  );
}
